// frontend/src/services/api.js
import axios from 'axios';

// ← CAMBIAR ESTA URL PARA QUE APUNTE A /api/content
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/content';

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para errores
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // No redirigir automáticamente, dejar que el componente maneje el error
      console.log('No autenticado - redirigir a login');
    }
    return Promise.reject(error);
  }
);

// Obtener CSRF token
function getCookie(name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.substring(0, name.length + 1) === (name + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

// Añadir CSRF token a peticiones POST/PUT/DELETE
api.interceptors.request.use((config) => {
  if (['post', 'put', 'patch', 'delete'].includes(config.method)) {
    config.headers['X-CSRFToken'] = getCookie('csrftoken');
  }
  return config;
});

// Enviar ruta frontend actual para tracking de actividad
api.interceptors.request.use((config) => {
  config.headers['X-Frontend-Path'] = window.location.pathname;
  return config;
});

// Interceptor para añadir token JWT de autenticación
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

export default api;